"use client";

import { useState } from "react";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { Lightbox } from "./Lightbox";
import { PATRIMOINE_PHARES, type Oeuvre } from "@/lib/diwline-data";
import { Expand } from "lucide-react";

const SPANS = [
  "sm:col-span-2 sm:row-span-2",
  "",
  "",
  "sm:row-span-2",
  "",
  "",
  "sm:col-span-2",
  "",
  "",
  "",
  "sm:col-span-2",
  "",
];

export function GaleriePatrimoine() {
  const [idx, setIdx] = useState<number | null>(null);
  const oeuvre = idx === null ? null : PATRIMOINE_PHARES[idx];

  const nav = (d: number) =>
    setIdx(cur => (cur === null ? null : (cur + d + PATRIMOINE_PHARES.length) % PATRIMOINE_PHARES.length));

  return (
    <section id="patrimoine" className="relative bg-royal-brown py-24 md:py-32" aria-label="Galerie du Patrimoine">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="VII"
          titre="Galerie du Patrimoine"
          intro="Plus de 40 œuvres thématiques illustrent la vision complète de Sa Majesté Adjia Daba : agriculture, portraits, éducation, finance, digital, héros nationaux, fêtes, bénévolat, recherche, santé, smart farming et gastronomie royale."
        />

        <Reveal>
          <div className="grid auto-rows-[170px] grid-cols-2 gap-3 sm:auto-rows-[190px] sm:grid-cols-4 md:auto-rows-[210px]">
            {PATRIMOINE_PHARES.map((o, i) => (
              <button
                key={o.src + i}
                type="button"
                onClick={() => setIdx(i)}
                className={`group relative overflow-hidden rounded-sm border border-gold/15 focus-visible:outline-gold ${SPANS[i % SPANS.length]}`}
                aria-label={`Agrandir : ${o.titre}`}
              >
                <img
                  src={o.src}
                  alt={o.titre}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-108"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                <span className="absolute bottom-3 left-3 right-3 flex items-end justify-between gap-2 opacity-0 transition-all duration-300 group-hover:opacity-100">
                  <span className="text-left text-[11.5px] font-medium leading-snug text-gold-light">
                    {o.titre}
                  </span>
                  <Expand className="h-4 w-4 shrink-0 text-gold" aria-hidden />
                </span>
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-8 text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-cream/50">
            12 œuvres phares présentées · Collection royale de plus de 40 œuvres
          </p>
        </Reveal>
      </div>

      <Lightbox oeuvre={oeuvre} onClose={() => setIdx(null)} onPrev={() => nav(-1)} onNext={() => nav(1)} />
    </section>
  );
}
